/* BY2-20 product page behavior.
   Runs against whichever BY2-20 sections are present on the page, so it is safe
   to load from every section and safe if a section is removed in the editor.

   The quote form is NOT handled here — it uses Shopify's {% form 'contact' %},
   which posts to the store and re-renders with a server-side confirmation. */
(function () {
  'use strict';

  /* --- Full specifications toggle --------------------------------------- */
  function initSpecs(scope) {
    var toggle = scope.querySelector('[data-specs-toggle]');
    var panel = scope.querySelector('[data-specs-panel]');
    if (!toggle || !panel || toggle.dataset.bound) return;
    toggle.dataset.bound = '1';

    var labels = {
      open: toggle.getAttribute('data-label-open'),
      closed: toggle.getAttribute('data-label-closed')
    };

    // Honour a section setting that renders the panel expanded.
    if (!panel.hidden) {
      toggle.setAttribute('aria-expanded', 'true');
      toggle.textContent = labels.open;
    }

    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? labels.open : labels.closed;
    });
  }

  /* --- Currency and model toggles ---------------------------------------- */
  /* Only rendered when the hero's price_source setting is "manual". When it is
     "product", price comes from {{ product.price | money }} and Shopify Markets
     owns currency, so there is no toggle to wire up.

     Two toggles share one price element. The currency toggle picks USD or CAD;
     the model toggle (series products, from the hero's "model" blocks) swaps
     which model's pair of prices the price element carries, then re-renders in
     whatever currency is active — so a visitor can compare models without
     scrolling to the model notes section. */
  function initCurrency(scope) {
    var priceEl = scope.querySelector('[data-price]');
    var codeEl = scope.querySelector('[data-price-code]');
    var group = scope.querySelector('[data-currency-toggle]');
    var models = scope.querySelector('[data-model-toggle]');
    if (!priceEl || (!group && !models)) return;
    if ((group && group.dataset.bound) || (models && models.dataset.bound)) return;
    if (group) group.dataset.bound = '1';
    if (models) models.dataset.bound = '1';

    var buttons = group ? group.querySelectorAll('[data-currency]') : [];
    var modelButtons = models ? models.querySelectorAll('[data-model]') : [];
    var current = 'usd';

    function render() {
      var amount = priceEl.getAttribute('data-price-' + current);
      // Fall back rather than blank the price if a model lacks this currency.
      if (!amount) {
        current = current === 'cad' ? 'usd' : 'cad';
        amount = priceEl.getAttribute('data-price-' + current);
      }
      if (!amount) return;

      priceEl.textContent = amount;
      if (codeEl) codeEl.textContent = current.toUpperCase();

      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('aria-pressed',
          String(buttons[i].getAttribute('data-currency') === current));
      }
    }

    function setCurrency(code) {
      if (!priceEl.getAttribute('data-price-' + code)) return;
      current = code;
      render();
    }

    function setModel(btn) {
      var usd = btn.getAttribute('data-price-usd');
      var cad = btn.getAttribute('data-price-cad');
      if (usd) priceEl.setAttribute('data-price-usd', usd);
      else priceEl.removeAttribute('data-price-usd');
      if (cad) priceEl.setAttribute('data-price-cad', cad);
      else priceEl.removeAttribute('data-price-cad');

      for (var i = 0; i < modelButtons.length; i++) {
        modelButtons[i].setAttribute('aria-pressed', String(modelButtons[i] === btn));
      }

      // Swap the hero image to this model's photo, the way WooCommerce swaps the
      // image when a variation is picked. Only present when every model in the
      // series resolved to its own slide.
      var idx = btn.getAttribute('data-image-index');
      if (idx !== null) {
        var car = scope.querySelector('[data-carousel]');
        if (car && typeof car.pfShow === 'function') car.pfShow(parseInt(idx, 10));
      }

      // Page templates that sell a picked product: the model buttons carry the
      // variant id, so the Add to cart form follows the toggle (2026-09-19).
      var vid = btn.getAttribute('data-variant-id');
      if (vid) {
        var inp = scope.querySelector('[data-pf-hero-variant]');
        if (inp) inp.value = vid;
      }

      render();
    }

    /* The toggle buttons submit the Markets localization form (Liquid renders
       them as type=submit), so the page reloads in the chosen currency. The
       swap here is only so the figure changes instantly while that happens. */
    if (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-currency]');
        if (btn) setCurrency(btn.getAttribute('data-currency'));
      });
    }
    if (models) {
      models.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-model]');
        if (btn) setModel(btn);
      });
    }

    // Seed from the server-rendered state: Liquid prints the store currency
    // (Shopify Markets) into the code element, and that is the only truth.
    // Nothing is remembered client-side any more - a localStorage choice used
    // to override it and show USD beside a CAD variant picker and cart.
    if (codeEl && codeEl.textContent) {
      current = codeEl.textContent.trim().toLowerCase() === 'cad' ? 'cad' : 'usd';
    }
    render();
  }


  /* --- Hero carousel ----------------------------------------------------- */
  /* Progressive enhancement: the Liquid marks every slide but the first as
     hidden, so with no JS the visitor still sees the primary image rather than
     eight stacked ones. */
  function initCarousel(scope) {
    var root = scope.querySelector('[data-carousel]');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';

    var slides = root.querySelectorAll('[data-slide]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var caption = root.querySelector('[data-carousel-caption]');
    var index = 0;

    function show(next) {
      index = (next + slides.length) % slides.length;   // wraps both directions
      for (var i = 0; i < slides.length; i++) {
        slides[i].hidden = i !== index;
        // A video keeps playing behind a hidden slide unless it is paused.
        var vid = slides[i].hidden && slides[i].querySelector('video');
        if (vid && !vid.paused) vid.pause();
      }
      for (var t = 0; t < thumbs.length; t++) {
        thumbs[t].setAttribute('aria-selected', String(t === index));
      }
      if (caption) caption.textContent = slides[index].getAttribute('data-alt') || '';
    }

    root.querySelector('[data-carousel-prev]').addEventListener('click', function () { show(index - 1); });
    root.querySelector('[data-carousel-next]').addEventListener('click', function () { show(index + 1); });

    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].addEventListener('click', function (e) {
        show(parseInt(e.currentTarget.getAttribute('data-thumb'), 10));
      });
    }

    // Left/right arrows move through images when focus is inside the carousel.
    root.addEventListener('keydown', function (e) {
      if (e.target.tagName === 'VIDEO') return;   // arrows seek inside a video
      if (e.key === 'ArrowLeft') { show(index - 1); }
      else if (e.key === 'ArrowRight') { show(index + 1); }
      else { return; }
      e.preventDefault();
    });

    // Expose so the model toggle can jump to a model's photo.

    root.pfShow = show;


    show(0);
  }

  /* --- FAQ accordion ------------------------------------------------------ */
  /* The markup is <details>, so it works and stays readable with JS off. This
     only adds the single-open behavior the spec asks for. */
  function initFaq(scope) {
    var items = scope.querySelectorAll('[data-faq-item]');
    for (var i = 0; i < items.length; i++) {
      if (items[i].dataset.bound) continue;
      items[i].dataset.bound = '1';
      items[i].addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        for (var j = 0; j < items.length; j++) {
          if (items[j] !== e.target) items[j].open = false;
        }
      });
    }
  }

  function init(scope) {
    initSpecs(scope);
    initCurrency(scope);
    initCarousel(scope);
    initFaq(scope);
  }

  init(document);

  // Re-run when a merchant adds or edits a section in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
